import {Component, ViewEncapsulation} from '@angular/core';

@Component({
    selector     : '.text-box-demo',
    encapsulation: ViewEncapsulation.None,
    template: `<h4>Text Box</h4>
<h5>Example</h5>
<div class="card card-body bg-light form-group">
    <form #testForm="ngForm">
        <check-box [(ngModel)]="model.required" name="required" label="Is Required" labelPlacement="after"></check-box>
        <check-box name="shouldMatch" label="Should Match Matching Field" [(ngModel)]="model.shouldMatch"
                   labelPlacement="after"></check-box>
        <text-box name="match" label="Matching Field" [(ngModel)]="model.match"></text-box>
        <text-box name="icon" label="Icon" [(ngModel)]="model.icon"></text-box>
        <div class="clearfix"></div>
        <text-box
                [name]="model.name"
                [type]="model.type"
                label="Test Text Field"
                [(ngModel)]="model.value"
                [matchValue]="model.shouldMatch ? {value:model.match,label:'Matching Field'} : null"
                [required]="model.required"
                [placeholder]="model.placeholder">
            <div class="input-group-prepend" *ngIf="model.icon.length > 0">
                <span class="input-group-text">
                    <span class="fa fa-{{model.icon}}"></span>
                </span>
            </div>
        </text-box>
        <submit-button label="Submit" [formGroup]="testForm.form"></submit-button>
    </form>
</div>
<h5>Data Model</h5>
<pre class="card card-body bg-light">{{ model | json }}</pre>
<h5>Markup</h5>
<pre class="card card-body bg-light">{{ markup }}</pre>
`
})
export class TextBoxDemoComponent {

    model = {
        name       : 'textBoxField',
        icon       : '',
        type: 'text',
        shouldMatch: false,
        match      : '',
        required   : false,
        placeholder: 'Example Text Field',
        value      : ''
    };

    markup = `
<text-box
        [name]="model.name"
        [type]="model.type"
        label="Test Text Field"
        [(ngModel)]="model.value"
        [matchValue]="model.shouldMatch ? {value:model.match,label:'Matching Field'} : null"
        [required]="model.required"
        [placeholder]="model.placeholder">
    <div class="input-group-prepend" *ngIf="model.icon.length > 0">
        <span class="input-group-text">
            <span class="fa fa-{{model.icon}}"></span>
        </span>
    </div>
</text-box>
    `;


}
